
// export const myMutation = ( state ) => {

// }

export const toggleLoading = ( state ) => {
    state.loading = !state.loading
}

export const setToast = (state, payload) => {
    state.toast = payload
}